<script>

export default {
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.create();
        },
        newData() {
            var vm = this;

            var data = {
                branch: 0,
                room: 0,
                open_hour: 0,
                special_day: 0,
                employee: 0,
                daily_reservation: 0,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('config_general_store_create');
            try {
                var resp = await this.$api.ConfigStore.get();
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('config_general_store_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async submit() {
            var vm = this;
            this.$loading.on('config_general_store_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.ConfigStore.create(postData);

                var data = resp.data;

                vm.create();

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('config_general_store_submit');
        },
        _createPostData: function (data) {

            return data;
        },
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol lg="12">
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('config_general_store_create')" variant="dark" type="block">
                            <BRow>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.branch')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.branch" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.branch')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.row')
                                        }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.room')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.room" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.room')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.row')
                                        }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.open_hour')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.open_hour" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.open_hour')" />
                                        <span class="input-group-text" id="basic-addon2">/{{ $t('basic.label.day')
                                        }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.special_day')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.special_day" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.special_day')" />
                                        <span class="input-group-text" id="basic-addon2">/{{ $t('basic.label.month')
                                        }}</span>
                                    </div>

                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.employee')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.employee" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.employee')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.person')
                                        }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.daily_reservation')
                                    }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.daily_reservation" class="form-control"
                                            id="email"
                                            :placeholder="$t('config_general.placeholder.daily_reservation')" />
                                        <span class="input-group-text" id="basic-addon2">/{{ $t('basic.label.branch')
                                        }}</span>
                                    </div>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                    <BCardFooter v-if="$ac.hasAccess('config_general_create')">
                        <div class="hstack gap-2 justify-content-end">
                            <BButton type="submit" variant="success" class="w-sm"
                                :disabled="$loading.get('config_general_store_submit')">
                                <loading :loading="$loading.get('config_general_store_submit')" variant="light"
                                    type="button">
                                    <i class="mdi mdi-floppy me-1"></i>
                                    {{ $t('basic.btn.save') }}
                                </loading>
                            </BButton>
                        </div>
                    </BCardFooter>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>